import {
 Flex,
 Stack,
 Checkbox,
 Text,
 RadioGroup,
 Radio,
 Box,
 Image,
 Button,
 useDisclosure,
 Table,
 Thead,
 Tbody,
 Tr,
 Th,
 Td,
} from '@chakra-ui/react';
import ButtonOnlyIcon from '../Button/Only-icon';
import { QuestionHelper } from '../Data';
import { InputText } from '../Input';
import { upload } from '../../assets/new-images/icons';
import React from 'react';
import { NumericFormat } from 'react-number-format';
import EditQuestionModal from '../Modals/EditQuestionModal';
import RotuloClassificacao from '../Catalog/RotuloClassificacao';
import RotuloGri from '../Catalog/RotuloGri';
import MedidasGriComoFormulario from '../Catalog/MedidasGriComoFormulario';

const QuestionCardCustom = React.memo(({ index, question, remove, edit, children }) => {
 const { code, type, helper, isRequired, is_required } = question;
 const { isOpen, onOpen, onClose } = useDisclosure();

 const description =
  question?.description || question?.questionTitleTemplate?.[0]?.description || '';

 const questionOptions = question?.options || question?.question_option_template || [];

 const isQuestionRequired = isRequired === 'Sim' || is_required === true;

 const shouldShowEvidenceButton =
  question?.request_files === true ||
  question?.request_images === true ||
  question?.requestFiles === 'Sim' ||
  question?.requestImages === 'Sim';

 return (
  <Stack
   spacing={['16px', '24px']}
   p='6'
   pb='26px'
   bg='white'
   borderRadius='12px'
   border='2px solid #EAEEF0'
   pos='relative'
  >
   <Box maxW='86%'>
    {isQuestionRequired && (
     <Text
      as='span'
      color='orange.100'
      fontSize='12px'
      lineHeight='24px'
      fontWeight={500}
     >
      Pergunta obrigatória*
     </Text>
    )}

    <Text lineHeight='32px' mt='4px'>
     <b>{code}</b> -{' '}
     <Text as='span' fontWeight={500} dangerouslySetInnerHTML={{ __html: description }} />
    </Text>

    {/* GRI-08: classificação e indicadores no fluxo de QUESTIONÁRIO (criação e
        edição). Este card não mostrava nenhum dos dois — quem monta o
        questionário não tinha como saber que a questão é classificada nem que
        ela alimenta indicador, apesar de as duas features existirem. */}
    <RotuloClassificacao
     idPillar={question?.id_pillar}
     idTheme={question?.id_theme}
     pillarName={question?.pillar_name}
     themeTitle={question?.theme_title}
     ocultarVazio
    />
    <RotuloGri gri={question?.gri} griIds={question?.gri_ids} comRotulo />
   </Box>

   <QuestionHelper description={helper?.description || ''} videoUrl={helper?.url_video} />

   {/* A mesma caixa que o respondente verá: um campo por indicador, com a
       unidade. Aqui é só previsão — quem monta o questionário precisa ver o
       que está criando. */}
   <MedidasGriComoFormulario gri={question?.gri} />
   {/* <Button onClick={() => console.log('question', question)}>question</Button> */}
   <Box>
    {(type === 'text' || type === 'number') && (
     <InputText
      name={`${question?.id || question?.id_question_template}`}
      type={type}
      width='400px'
     />
    )}

    {type === 'money' && (
     <NumericFormat
      displayType='input'
      thousandSeparator=','
      decimalSeparator='.'
      prefix='R$ '
      decimalScale={3}
      className='money_input'
      placeholder='R$ '
     />
    )}

    {type === 'percentage' && (
     <NumericFormat
      suffix='%'
      displayType='input'
      maxLength={4}
      fixedDecimalScale
      className='percentage_input'
      placeholder='% '
     />
    )}

    {type === 'multi_choice' && (
     <RadioGroup>
      <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
       {questionOptions?.map(
        (option, i) =>
         option?.description && (
          <Radio key={i} value={option?.value} isReadOnly>
           {option.description}
          </Radio>
         )
       )}
      </Flex>
     </RadioGroup>
    )}

    {type === 'multiple_choice' && (
     <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
      {questionOptions?.map(
       (option, i) =>
        option?.description && (
         <Checkbox
          key={i}
          value={option?.value}
          name={`${question?.id}_${i}`}
          className='questionary-checkbox'
         >
          {option.description}
         </Checkbox>
        )
      )}
     </Flex>
    )}

    {type === 'grid' && question.gridRows && (question.gridColumns || question.options) && (
     <Box overflowX='auto' border='1px solid' borderColor='gray.200' borderRadius='md'>
      <Table variant='simple' size='sm'>
       <Thead bg='gray.50'>
        <Tr>
         <Th w='200px'></Th>
         {(question.gridColumns || question.options).map((col, colIndex) => (
          <Th key={colIndex} textAlign='center' fontSize='xs'>
           {col.description}
          </Th>
         ))}
        </Tr>
       </Thead>
       <Tbody>
        {question.gridRows.map((row, rowIndex) => (
         <Tr key={rowIndex}>
          <Td fontWeight='500' fontSize='sm'>
           {row.description}
          </Td>
          {(question.gridColumns || question.options).map((col, colIndex) => (
           <Td key={colIndex} textAlign='center'>
            <Radio 
             isDisabled 
             value={`${rowIndex}-${colIndex}`}
            />
           </Td>
          ))}
         </Tr>
        ))}
       </Tbody>
      </Table>
     </Box>
    )}
   </Box>

   {shouldShowEvidenceButton && (
    <Button
     alignSelf='flex-start'
     color='blue.100'
     bg='white'
     h='32px'
     p={0}
     display='flex'
     alignItems='center'
     _hover={{
      bg: 'none',
     }}
     _active={{
      bg: 'none',
     }}
    >
     <Image src={upload} alt='Upload icon' mr='4px' />
     <Text as='span' fontSize='sm' textDecor='underline' fontWeight={600}>
      Anexar Evidências
     </Text>
    </Button>
   )}
  {edit && 
    <>
    <ButtonOnlyIcon
      name='edit'
      h='32px'
      pos='absolute'
      right='56px'
      top='24px'
      onClick={onOpen}
    />
    <EditQuestionModal 
      isOpen={isOpen}
      onClose={onClose}
      index={index}
      edit={edit}
      question={question}
    />
  </>
  }
   <ButtonOnlyIcon
    name='trash'
    h='32px'
    pos='absolute'
    right='24px'
    top='24px'
    onClick={remove}
   />
   {children}
  </Stack>
 );
});

export default QuestionCardCustom;
